import { FILTER_LABELS } from './config';

class RecipesFilter {
  DB: typeof window.storeTheme.helpers.db;
  page: number;
  pageSize: number;
  btnloadMore: HTMLElement;
  filters: { [key: string]: any } = {};
  // filtredItems: any[];
  filtredItemsTotal: number;
  selectors: { [key: string]: string };
  templateRender: { [key: string]: (obj: unknown) => string };
  dinamicView;

  constructor(props) {
    this.selectors = props.selectors;
    this.templateRender = props.templateRender;
    const shelfFilterItem = document.querySelector(this.selectors.shelfFilterItem)?.innerHTML || '';
    if (shelfFilterItem) {
      Object.assign(this.templateRender, {
        shelfFilterItem: (obj) => {
          return window.storeTheme.helpers.mustache.render(shelfFilterItem, obj);
        },
      });

      window.storeTheme.helpers.mustache.parse(shelfFilterItem);

      this.page = 0;
      this.pageSize = 8;
      this.DB = props.DB;
      this.btnloadMore = document.querySelector(this.selectors.shelfBlockbtnShowMore);
      this.bindEvents();
      this.createMainFilterOptions();
      this.whenFilterChange();
    } else {
      console.warn('🔴 Template de filtro de receira não disponível!');
    }
  }

  /**
   * Registro de eventos
   */
  bindEvents() {
    if (this.btnloadMore) {
      this.btnloadMore.addEventListener('click', () => {
        this.nextPage();
      });
    }
  }

  /**
   * Seta a página atual
   * @param page number
   */
  setPage(page) {
    this.page = page;
  }

  /**
   * Adiciona um novo filtro a lista de fltros aplicados
   * @param key string
   * @param value any
   */
  addFilter(key, value) {
    Object.assign(this.filters, { [key]: value });
    this.whenFilterChange();
  }

  /**
   * Remove um determinado filtro da lista de filtros aplicados
   * @param key string
   */
  removeFilter(key) {
    if (this.filters.hasOwnProperty(key)) {
      delete this.filters[key];
    }

    this.whenFilterChange();
  }

  /**
   * Verifica se existe algum filtro aplicado
   * @returns boolean
   */
  hasFilters() {
    return !!Object.keys(this.filters).length;
  }

  /**
   * Quanto for alterada a lista de itens filtrados
   */
  async whenFilterChange() {
    this.setPage(0);
    this.createDinamicView();
    this.filtredItemsTotal = this.dinamicView.count();
    this.showItems();
  }

  /**
   * Verifica se existe uma próxima página
   * @returns boolean
   */
  hasNextPage() {
    return this.pageSize * (this.page + 1) < this.filtredItemsTotal;
  }

  /**
   * Cria uma visualização dinâmica para o filtro
   */
  createDinamicView() {
    const collection = this.DB.getCollection('receitas');
    const dv = collection.addDynamicView('filter');
    dv.applyWhere((obj) => {
      return !!obj.visible;
    });

    if (this.hasFilters()) {
      dv.applyWhere((obj) => {
        const { categoryId, categoryId2, categoryId3, categoryId4, categoryId5 } = obj;
        const categories = [categoryId, categoryId2, categoryId3, categoryId4, categoryId5];
        // todos os filtros precisam ser verdadeiros
        return !Object.keys(this.filters)
          .map((key) => {
            if (key === 'type1' || key === 'type2') {
              return categories.includes(this.filters[key]);
            }

            return obj.hasOwnProperty(key) && obj[key] === this.filters[key];
          })
          // se algum possuir o valor falso, significa que não alcançou a expectativa
          .includes(false);
      });
    }
    this.dinamicView = dv.branchResultset().simplesort('createdIn', true);
  }

  /**
   * Retorna uma lista de itens filtroados
   * @param offset number
   * @param limit number
   * @returns []
   */
  async getItems(offset, limit) {
    return this.dinamicView.offset(offset).limit(limit).data();
  }

  /**
   * Adiciona os itens filtrados no DOM
   */
  async showItems() {
    const items = await this.getItems(this.pageSize * this.page, this.pageSize);
    const $box = document.querySelector(this.selectors.shelfBlockFiltered);
    if ($box) {
      if (!items.length) {
        $box.innerHTML = 'Não há items para exibir com essas opções de filtro aplicadas.';
        return;
      }
      const htmlItems = items
        .map((recipe) => {
          return this.templateRender.shelfItemTemplate({
            ...recipe,
            classNames: 'col-6 col-xl-3',
          });
        })
        .join('');

      if (this.page > 0) {
        $box.insertAdjacentHTML('beforeend', htmlItems);
      } else {
        $box.innerHTML = htmlItems;
      }
    }

    this.visibilityOfBtnLoad();
  }

  /**
   * Verifica se deve ou não exibir o botão para carregar mais items.
   * Caso sim, trata a exibição do botão
   * @returns void
   */
  visibilityOfBtnLoad() {
    if (!this.btnloadMore) {
      return;
    }

    if (this.hasNextPage()) {
      this.btnloadMore.classList.remove('d-none');
      return;
    }
    this.btnloadMore.classList.add('d-none');
  }

  /**
   * Apresenta a próxima página
   */
  nextPage() {
    this.setPage(this.page + 1);
    this.showItems();
  }

  /**
   * Reseta a listagem para página inicial
   */
  resetItems() {
    this.setPage(0);
    this.showItems();
  }

  createMainFilterOptions() {
    const data = this.DB.getCollection('receitas').find({ visible: { $eq: true } });
    const mapTypes = {
      type1: 'Tipos',
      type2: 'Ocasiões',
    };
    const mainFilterOptions = {
      type1: [],
      type2: [],
      difficulty: [],
    };

    data.forEach((receita) => {
      const { categoryId, categoryId2, categoryId3, categoryId4, categoryId5, difficulty: difficultyId } = receita;
      [categoryId, categoryId2, categoryId3, categoryId4, categoryId5]
        .filter((item) => !!item)
        .forEach((id) => {
          const category = this.DB.getCollection('categorias').findOne({ id: { $eq: id } });
          if (!category) {
            return;
          }
          if (category) {
            const item = {
              id,
              name: category.name,
            };

            if (category.type === mapTypes.type1 && !mainFilterOptions.type1.find((item) => item.id === id)) {
              mainFilterOptions.type1.push(item);
            } else if (category.type === mapTypes.type2 && !mainFilterOptions.type2.find((item) => item.id === id)) {
              mainFilterOptions.type2.push(item);
            }
          }
        });
      const difficultyObj = this.DB.getCollection('dificuldades').findOne({ id: { $eq: difficultyId } });

      if (difficultyObj && !mainFilterOptions.difficulty.find((item) => item.id === difficultyId)) {
        mainFilterOptions.difficulty.push({
          id: difficultyId,
          name: difficultyObj.name,
        });
      }
    });

    Object.keys(mainFilterOptions).forEach((key) => {
      const filter = document.querySelector(`${this.selectors.filterBar} [data-filter-item="${key}"]`);
      const filterLabels = FILTER_LABELS;
      if (!filter) {
        return;
      }
      const filterItems = mainFilterOptions[key]
        .map((item) => {
          return this.templateRender.shelfFilterItem(item);
        })
        .join('');

      filter.querySelector('.dropdown-menu ul').innerHTML = filterItems;
      filter.querySelectorAll('a')?.forEach((link) =>
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const value = link.getAttribute('data-value');

          if (this.filters.hasOwnProperty(key) && this.filters[key] === value) {
            link.classList.remove('selected');
            this.removeFilter(key);
            filter.querySelector('.btn-text').innerHTML = filterLabels[key];
            return;
          }

          link.classList.add('selected');
          this.addFilter(key, value);
          filter.querySelector('.btn-text').innerHTML = link.innerText;
        }),
      );
    });
  }
}

export default RecipesFilter;
